import {
  createErrorType,
  createSuccessType,
  createFetchType,
  createLoadingType,
  createSubmitType,
  createUpdateType,
} from '../actionHelpers';

const IDENTIFICATION_TYPES_SOURCE_SCOPE = 'IDENTIFICATION_TYPES_SOURCE';
export const GET_IDENTIFICATION_TYPES_SOURCE = createFetchType(
  IDENTIFICATION_TYPES_SOURCE_SCOPE,
);
export const GET_IDENTIFICATION_TYPES_SUCCESS = createSuccessType(
  IDENTIFICATION_TYPES_SOURCE_SCOPE,
);
export const GET_IDENTIFICATION_TYPES_ERROR = createErrorType(
  IDENTIFICATION_TYPES_SOURCE_SCOPE,
);
export const GET_IDENTIFICATION_TYPES_LOADING = createLoadingType(
  IDENTIFICATION_TYPES_SOURCE_SCOPE,
);

const IDENTIFICATION_SOURCE_SCOPE = 'IDENTIFICATION_SOURCE_DETAILS';
export const IDENTIFICATION_SOURCE_DETAILS = createFetchType(
  IDENTIFICATION_SOURCE_SCOPE,
);
export const IDENTIFICATION_SOURCE_DETAILS_ERROR = createErrorType(
  IDENTIFICATION_SOURCE_SCOPE,
);
export const IDENTIFICATION_SOURCE__DETAILS_SUCCESS = createSuccessType(
  IDENTIFICATION_SOURCE_SCOPE,
);
export const IDENTIFICATION_SOURCE__DETAILS_LOADING = createLoadingType(
  IDENTIFICATION_SOURCE_SCOPE,
);

const POST_IDENTIFICATION_INFO_SCOPE = 'POST_IDENTIFICATION_INFO';
export const POST_IDENTIFICATION_INFO = createSubmitType(
  POST_IDENTIFICATION_INFO_SCOPE,
);
export const POST_IDENTIFICATION_INFO_SUCCESS = createSuccessType(
  POST_IDENTIFICATION_INFO_SCOPE,
);
export const POST_IDENTIFICATION_INFO_ERROR = createErrorType(
  POST_IDENTIFICATION_INFO_SCOPE,
);
export const POST_IDENTIFICATION_INFO_LOADING = createLoadingType(
  POST_IDENTIFICATION_INFO_SCOPE,
);

const UPDATE_IDENTIFICATION_INFO_SCOPE = 'PUT_IDENTIFICATION_INFO';
export const UPDATE_IDENTIFICATION_INFO = createUpdateType(
  UPDATE_IDENTIFICATION_INFO_SCOPE,
);
export const UPDATE_IDENTIFICATION_INFO_SUCCESS = createSuccessType(
  UPDATE_IDENTIFICATION_INFO_SCOPE,
);
export const UPDATE_IDENTIFICATION_INFO_ERROR = createErrorType(
  UPDATE_IDENTIFICATION_INFO_SCOPE,
);
export const UPDATE_IDENTIFICATION_INFO_LOADING = createLoadingType(
  UPDATE_IDENTIFICATION_INFO_SCOPE,
);
